/**
 * Input Schema of SaraivaCnpjDisponivel
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {SaraivaCnpjDisponivel} from '@/model/resource/SaraivaCnpjDisponivel'

/* TODO: review generated schema */
export class InputSaraivaCnpjDisponivelSchema extends Schema {
  readonly name = 'InputSaraivaCnpjDisponivel'

  readonly fieldSet: FieldSet<SaraivaCnpjDisponivel> = {
    cnpjRaiz: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 10,
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
  }
}
